import script from "./LoginModal.vue?vue&type=script&lang=ts&name=LoginModal&setup=true"
export * from "./LoginModal.vue?vue&type=script&lang=ts&name=LoginModal&setup=true"

import "./LoginModal.vue?vue&type=style&index=0&id=3e29f0cf&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e29f0cf"]])

export default __exports__